import { Component, computed, input, output } from "@angular/core";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: "reusable-paginator",
  standalone: true,
  imports: [MatMenuModule, MatTooltipModule],
  templateUrl: "./reusable-paginator.component.html",
  styleUrls: ["./reusable-paginator.component.scss"],
})
export class ReusablePaginatorComponent {
  totalItems = input.required<number>();
  pageSize = input.required<number>();
  currentPage = input.required<number>();
  pageSizeOptions = input<number[]>([5, 10, 20, 50]);
  pageChange = output<number>();
  pageSizeChange = output<number>();

  readonly totalPages = computed(() =>
    Math.max(1, Math.ceil(this.totalItems() / Math.max(1, this.pageSize()))),
  );
  readonly middlePages = computed(() =>
    Array.from({ length: Math.max(0, this.totalPages() - 4) }, (_, i) => i + 3),
  );
  readonly showEllipsis = computed(() => this.totalPages() > 4);
  readonly isFirstPage = computed(() => this.currentPage() <= 1);
  readonly isLastPage = computed(() => this.currentPage() >= this.totalPages());
  readonly currentIsMiddle = computed(
    () => this.currentPage() > 2 && this.currentPage() < this.totalPages() - 1,
  );

  previousPage(): void {
    if (!this.isFirstPage()) this.goToPage(this.currentPage() - 1);
  }
  nextPage(): void {
    if (!this.isLastPage()) this.goToPage(this.currentPage() + 1);
  }

  goToPage(page: number): void {
    const target = Math.min(Math.max(1, page), this.totalPages());
    if (target !== this.currentPage()) this.pageChange.emit(target);
  }

  changePageSize(size: number): void {
    if (this.pageSizeOptions().includes(size) && size > 0) {
      this.pageSizeChange.emit(size);
      if (this.currentPage() !== 1) this.pageChange.emit(1);
    }
  }
}
